module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_blue.32cb8a8e.svg";